import { useQuery } from "@tanstack/react-query";
import { SystemLicenses } from "@graylog/enterprise-api";
import UserNotification from "util/UserNotification";
import { onError } from "util/conditional/onError";
import { LICENSE_SUBJECTS } from "license/constants";
const notifyUnlessMissing = (error) => {
  let skip = false;
  try {
    skip = error.additional.status === 404;
  } catch (_) {
    skip = false;
  }
  if (skip) {
    return;
  }
  let errorMessage;
  try {
    errorMessage = error.additional.body.message;
  } catch (_) {
    errorMessage = error.message;
  }
  UserNotification.error(`Fetching Events license failed: ${errorMessage}`, "Could not retrieve Events license");
};
const fetchEventsLicenseStatus = () => onError(SystemLicenses.validityForSubject(LICENSE_SUBJECTS.enterprise), notifyUnlessMissing);
export const EVENTS_LICENSE_STATUS_QUERY_KEY = ["event-correlation", "events-license-status"];
const useEventsLicenseStatus = () => {
  const { data, isFetching, isError } = useQuery({
    queryKey: EVENTS_LICENSE_STATUS_QUERY_KEY,
    queryFn: fetchEventsLicenseStatus,
    retry: false,
    // Non-standard on purpose: this hook derives its { status, missing, loading } return from
    // isFetching/isError (not error), so those props must trigger re-renders. Do not normalize to ['data', 'error'].
    notifyOnChangeProps: ["data", "isFetching", "isError"]
  });
  return {
    status: isError ? null : data != null ? data : void 0,
    missing: isError || !isFetching && data === void 0,
    loading: isFetching
  };
};
export default useEventsLicenseStatus;
